import type React from "react";

import type { ServicePartnerPageDetailsDto } from "@/api/types";
import { AlertCircleIcon } from "@/components/Icons/AlertCircleIcon";
import { Home02Icon } from "@/components/Icons/Home02Icon";
import { Inline } from "@/design-system/Inline";
import { useSessionUser } from "@/hooks/Network/useSessionUser";
import { useTranslation } from "@/translations";

import { ServiceDetailsBlockCard } from "../ServiceDetailsBlockCard";

interface IqbiDetailInfoCardProps {
  serviceDetails: ServicePartnerPageDetailsDto;
}
export function IqbiDetailsInfoCard({ serviceDetails }: IqbiDetailInfoCardProps): React.ReactNode {
  const { t } = useTranslation();
  const sessionUser = useSessionUser();
  const iqbiStatus = serviceDetails.partnerProperties.iqbi?.status;

  // Hide address if user has not given consent or is waiting for consent approval
  if (iqbiStatus === "noConsent" || iqbiStatus === "waitingForConsentApproval") return null;

  // If user consent request has been approved, but user has not verified the address
  if (iqbiStatus === "notVerified") {
    return (
      <ServiceDetailsBlockCard title={t("page.service-details.iqbi-address.title")}>
        <Inline gap="sm" align="center">
          <AlertCircleIcon size={22} tone="danger-tertiary" />
          <p>{t("page.service-details.iqbi-consumption.no-access")}</p>
        </Inline>
      </ServiceDetailsBlockCard>
    );
  }

  return (
    <ServiceDetailsBlockCard title={t("page.service-details.iqbi-address.title")}>
      <Inline gap="sm" align="center">
        <Home02Icon size={28} />
        <p className="text-text-primary">
          {sessionUser.address ? (
            <>
              {sessionUser.address.location}
              <br />
              {sessionUser.address.postalCode} {sessionUser.address.city}
            </>
          ) : (
            sessionUser.company?.name
          )}
        </p>
      </Inline>
    </ServiceDetailsBlockCard>
  );
}
